export default "__VITE_ASSET__BOWhUK2O__"